import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'ecp-image-data',
  template: `
    <div
      class="cloudimage-360"
      [attr.data-folder]="env"
      [attr.data-filename]="filename"
      data-amount="12"
      data-magnifier="3"
      data-spin-reverse
    ></div>
  `,
})
export class ImageDataComponent implements OnInit {
  @Input() name: string;
  filename;
  env;
  constructor() {}

  ngOnInit() {
    this.filename = `${this.name}_{index}.jpg`;
    this.env = environment.image360Url;
  }
}
